<template>
  <section v-if="data">
    <pagesJournalsQueryTagsComponent
      :data="tagsData?.data"
    />
    <pagesJournalsQueryListComponent
      :data="data?.data"
    />
    <pagesJournalsQueryPaginationComponent
      v-if="data?.meta?.pagination?.pageCount > 1"
      :pagination="data?.meta?.pagination"
      @setPage="page = $event"
    />
  </section>

  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script setup>
import { omit } from 'lodash-es'
const route = useRoute()
const router = useRouter()

// FIXME temp fix
const i18nIso = 'nl-NL' //baseI18nGetDefaultIso()

// 1
const { data: tagsData, error: tagsError } = await useAsyncData(() =>
  fetchQueryPath( queryJournalsTags(i18nIso) )
)

const journalTagsId = computed(() => {
  return route?.query?.tagId
})

// 2
const page = ref(route?.query?.page || 1)
const { data, error } = await useAsyncData(() =>
  fetchQueryPath( queryJournalEntriesThumbnail({ page: page.value, locale: i18nIso, tagId: journalTagsId.value }) ), { watch: [ page, journalTagsId ] }
)

watch(data, () => {
  if (process.client) {
    window.scroll(0, 0)
  }
})

watch(page, (val) => {
  const isOne = val === 1
  const queryObject = isOne ? omit(filterRouteQuery(route.query), 'page') : { ...filterRouteQuery(route.query), page: val }
  router.push({ query: queryObject })
})
</script>
